// @flow
import {
  CHANGE_LAYOUT,
  CHANGE_LAYOUT_WIDTH,
  CHANGE_SIDEBAR_THEME,
  CHANGE_SIDEBAR_TYPE,
  CHANGE_TOPBAR_THEME,
  SHOW_TOPBAR_INSIDE,
  SHOW_RIGHT_SIDEBAR,
  TOGGLE_LEFTMENU,
  SHOW_SIDEBAR,
  IS_LOADING,
  MENU_ACTIVED,
  IS_TRANSACTION_NOT_FOUND,
  IS_MODAL_PAGE,
  IS_TRANSACTION_WITH_ERROR,
  IS_IFRAME_PAGE,
} from "./actionTypes";

//constants
import {
  layoutTypes,
  layoutWidthTypes,
  topBarThemeTypes,
  leftSidebarTypes,
  leftSideBarThemeTypes,
  TopBarInsideTypes
} from "../../constants/layout";

const INIT_STATE = {
  layoutType: layoutTypes.VERTICAL,
  layoutWidth: layoutWidthTypes.FLUID,
  leftSideBarTheme: leftSideBarThemeTypes.LIGHT,
  leftSideBarType: leftSidebarTypes.COMPACT,
  topbarTheme: topBarThemeTypes.DARK,
  topbarInside: { isActive: TopBarInsideTypes.isActive.INACTIVE, payload: [], id: null},
  showRightSidebar: false,
  isMobile: false,
  showSidebar: true,
  leftMenu: false,
  isLoading: false,
  menuActived: false,
  transactionNotFound: false,
  transactionWithError: {
    payload: null
  },
  isModalPage: false,
  isIframePage: false
};

const Layout = (state = INIT_STATE, action) => {
  switch (action.type) {
    case IS_TRANSACTION_NOT_FOUND:
      return {
        ...state,
        transactionNotFound: action.payload,
      };
    case IS_TRANSACTION_WITH_ERROR:
      return {
        ...state,
        transactionWithError: action.payload,
      };
    case IS_MODAL_PAGE:
      return {
        ...state,
        isModalPage: action.payload,
      };
    case IS_IFRAME_PAGE:
      return {
        ...state,
        isIframePage: action.payload,
      };
    case CHANGE_LAYOUT:
      return {
        ...state,
        layoutType: action.payload,
      };
    case CHANGE_LAYOUT_WIDTH:
      return {
        ...state,
        layoutWidth: action.payload,
      };
    case CHANGE_SIDEBAR_THEME:
      return {
        ...state,
        leftSideBarTheme: action.payload,
      };
    case CHANGE_SIDEBAR_TYPE:
      return {
        ...state,
        leftSideBarType: action.payload.sidebarType,
      };
    case CHANGE_TOPBAR_THEME:
      return {
        ...state,
        topbarTheme: action.payload,
      };
    case SHOW_TOPBAR_INSIDE:
      return {
        ...state,
        topbarInside: action.payload,
      };
    case SHOW_RIGHT_SIDEBAR:
      return {
        ...state,
        showRightSidebar: action.payload,
      };
    case SHOW_SIDEBAR:
      return {
        ...state,
        showSidebar: action.payload,
      };
    case TOGGLE_LEFTMENU:
      return {
        ...state,
        leftMenu: action.payload,
      };
      
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case MENU_ACTIVED:
      return {
        ...state,
        menuActived: action.payload,
      };

    default:
      return state;
  }
};

export default Layout;
